import React from 'react';

/**
 * The site footer from the eyes/ landing pages: wordmark, socials, link row
 * and copyright. Markup is the original's; `home` picks the link style the
 * source documents used, as in [EyesNav](./EyesNav.js).
 */
export default function EyesFooter({ home = false }) {
  const sect = (name) => (home ? `#${name}` : `/#${name}`);

  return (
    <footer className="eyes-footer">
      {' '}
      <div className="eyes-footer-inner">
        {' '}
        <a className="eyes-footer-logo" href={home ? '#' : '/'} aria-label="The Eyes">
          {' '}
          <img src="/eyes/assets/776ab65b02.png" alt="The Eyes Are Always Watching" />
          {' '}
        </a>
        {' '}
        <div className="eyes-footer-socials">
          {' '}
          <a href="https://www.x.com/theeyesbtc" target="_blank" rel="noopener" aria-label="X / Twitter">
            {' '}
            <svg viewBox="0 0 24 24">
              <path d="M18.244 2H21.5l-7.11 8.13L22.75 22h-6.546l-5.126-6.7L5.22 22H1.96l7.6-8.69L1.54 2h6.712l4.633 6.124L18.244 2Zm-1.143 17.91h1.804L7.27 3.99H5.334L17.1 19.91Z" />
            </svg>
            {' '}
          </a>
          {' '}
          <a href="#" aria-label="Discord">
            {' '}
            <svg viewBox="0 0 24 24">
              <path d="M19.54 5.34A16.3 16.3 0 0 0 15.44 4l-.5 1.03a15.1 15.1 0 0 0-5.86 0L8.56 4a16.5 16.5 0 0 0-4.1 1.34C1.87 9.2 1.17 12.97 1.52 16.69a16.5 16.5 0 0 0 5.03 2.54l1.23-1.68a10.7 10.7 0 0 1-1.93-.92l.47-.36c3.72 1.72 7.76 1.72 11.43 0l.48.36c-.62.37-1.27.68-1.94.92l1.23 1.68a16.4 16.4 0 0 0 5.02-2.54c.42-4.31-.72-8.04-3-11.35ZM8.68 14.42c-1.12 0-2.04-1.03-2.04-2.3s.9-2.3 2.04-2.3c1.15 0 2.06 1.04 2.04 2.3 0 1.27-.9 2.3-2.04 2.3Zm6.64 0c-1.12 0-2.04-1.03-2.04-2.3s.9-2.3 2.04-2.3c1.15 0 2.06 1.04 2.04 2.3 0 1.27-.89 2.3-2.04 2.3Z" />
            </svg>
            {' '}
          </a>
          {' '}
        </div>
        {' '}
        <nav className="eyes-footer-nav" aria-label="Footer navigation">
          {' '}
          <a href={sect('about')}>
            ABOUT
          </a>
          {' '}
          <a href={sect('lore')}>
            LORE
          </a>
          {' '}
          <a href={sect('why-ordinals')}>
            WHY ORDINALS
          </a>
          {' '}
          <a href={sect('gallery')}>
            GALLERY
          </a>
          {' '}
          <a href="/watch">
            WATCH
          </a>
          {' '}
          <a href={sect('faq')}>
            FAQ
          </a>
          {' '}
        </nav>
        {' '}
        <div className="eyes-footer-copy">
          © 2026 THE EYES. ALL RIGHTS RESERVED.
        </div>
        {' '}
        <a className="eyes-footer-legal" href="/disclaimer">
          DISCLAIMER
        </a>
        {' '}
      </div>
      {' '}
    </footer>
  );
}
